import { InputNumber } from "antd";
import { useEffect, useState } from "react";
import { Controller, useFormContext } from "react-hook-form";

const ComRateInput = (props) => {
  const { num, actionSum } = props;
  const { register, setValue, watch, getValues, control } = useFormContext();
  const yearStatusWatch = watch(`year_status.year${num}_status`);
  // const yearfeeWatch = watch(`year_fee.year${num}_fee`);
  const handleDisable = () => {
    const enableVal = yearStatusWatch ? 0 : 1;
    setValue(`year_status.year${num}_status`, enableVal);
    if (enableVal) {
      setValue(`year_fee.year${num}_fee`, '0')
    } else {
      setValue(`year_fee.year${num}_fee`, '')
    }
  }

  return (
    <div className="text-center dealer_com w-[95px]" key={num}>
      <p className="text-[#495159] mb-[12px] text-[13px]">{num}</p>
      <div className={`custom_switch ${!yearStatusWatch && 'disable'} cursor-pointer`} onClick={handleDisable}>
        <span className="sw_text">{!yearStatusWatch ? 'NA' : 'AVL'}</span>
        <input type="checkbox" className="hidden" {...register(`year_status.year${num}_status`)} />
        <span className="thumb"></span>
      </div>
      <Controller
        control={control}
        name={`year_fee.year${num}_fee`}
        rules={{
          required: yearStatusWatch ? true : false,
        }}
        render={({ field }) => {
          return (
            <InputNumber
              type="number"
              min={0}
              style={{ width: 70, borderColor: '#C3D2E2' }}
              {...field}
              step="0.01"
              precision={2}
              disabled={!yearStatusWatch}
              placeholder="NA"
              className={`cusComInputNumber mt-[12px] ${!yearStatusWatch && 'opacity-[0.5]'}`}
            />
          )
        }}
      />
    </div>
  )
};

export default ComRateInput;
